import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.projects.mine.group');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-projects-mine-group',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.projects.mine.group/view.scss */
/* src/app/page.projects.mine.group/view.scss: no such file or directory */`],
})
export class PageProjectsMineGroupComponent implements OnInit, OnDestroy {
    public groups: any[] = [];
    public selectedGroup: any = null;
    public projects: any[] = [];
    public groupStatusFilter: string = 'active';
    public projectStatusFilter: string = 'active';
    public projectTypeFilter: string = 'all';
    public projectSort: string = 'name_asc';
    public groupStatusCounts: any = { active: 0, archived: 0, disabled: 0, deleted: 0 };
    public projectStatusCounts: any = { active: 0, archived: 0, disabled: 0, deleted: 0 };
    public loading: boolean = true;
    public saving: boolean = false;
    public showCreate: boolean = false;
    public showCreateGroup: boolean = false;
    public savingGroup: boolean = false;
    public showGroupManage: boolean = false;
    public savingGroupSettings: boolean = false;
    public deletingGroup: boolean = false;
    public restoringGroup: boolean = false;
    public savingGroupMember: boolean = false;
    public savingGroupRoleId: string = '';
    public sendingGroupInviteId: string = '';
    public removingGroupInviteId: string = '';
    public leavingGroup: boolean = false;
    public approvingJoinRequestId: string = '';
    public rejectingJoinRequestId: string = '';
    public mobileGroupActionsOpen: boolean = false;
    public groupManageTab: string = 'info';
    public groupDeleteConfirmName: string = '';
    public filters: any = { text: '', label: '', group_label: '' };
    public tagFilterOpen: boolean = false;
    public tagFilterQuery: string = '';
    public groupTagFilterOpen: boolean = false;
    public groupTagFilterQuery: string = '';
    public projectPage: number = 1;
    public projectPageSize: number = 10;
    public groupPage: number = 1;
    public groupPageSize: number = 12;
    public projectCatalogAllowed: boolean = true;
    public projectCreationAllowed: boolean = true;
    public adminMode: boolean = false;
    public form: any = this.blankForm();
    public groupForm: any = this.blankGroupForm();
    public userOptions: any[] = [];
    public loadingUserOptions: boolean = false;
    public memberUserOpen: boolean = false;
    public memberForm: any = { user_id: '', query: '', role: 'reviewer' };
    public documentBusy: boolean = false;
    public documentDropActive: boolean = false;
    public documentUploadProgress: any = { visible: false, fileName: '', percent: 0, loaded: 0, total: 0, status: '', message: '' };
    public uploadSettings: any = { policies: {} };
    public documentUploadAccept: string = 'application/pdf,.pdf';
    public documentUploadLimits: any = { fileBytes: 500 * 1024 * 1024 };
    public projectTypeOptions: any[] = [
        { value: 'web_service', label: '웹서비스', description: 'URL 기반 화면 리뷰' },
        { value: 'pdf', label: 'PDF', description: 'PDF 파일 리뷰' },
        { value: 'html', label: 'HTML', description: 'HTML 화면 리뷰' }
    ];
    public htmlLayoutPresetOptions: any[] = [
        { value: 'a4_portrait', label: 'A4 세로', width: 1240, height: 1754, render_mode: 'document' },
        { value: 'a4_landscape', label: 'A4 가로', width: 1754, height: 1240, render_mode: 'document' },
        { value: 'slide_16_9', label: '16:9', width: 1920, height: 1080, render_mode: 'document' },
        { value: 'slide_4_3', label: '4:3', width: 1024, height: 768, render_mode: 'document' },
        { value: 'web', label: '웹 해상도', width: 1440, height: 900, render_mode: 'web' },
        { value: 'custom', label: '직접 입력', width: 1440, height: 900, render_mode: 'web' }
    ];
    public projectTypeFilterOptions: any[] = [
        { value: 'all', label: '전체' },
        { value: 'pdf', label: 'PDF' },
        { value: 'html', label: 'HTML' },
        { value: 'web_service', label: '웹서비스' },
    ];
    public visibilityOptions: any[] = [
        { value: 'private', label: '비공개', description: '구성원만 접근' },
        { value: 'public', label: '공개', description: '로그인 사용자 접근' }
    ];
    public projectStatusOptions: any[] = [
        { value: 'active', label: '활성', description: '리뷰 접수 가능' },
        { value: 'archived', label: '보관', description: '기록 중심 관리' },
        { value: 'disabled', label: '비활성', description: '접근 일시 중지' }
    ];
    public groupMemberRoleOptions: any[] = [
        { value: 'owner', label: '소유자' },
        { value: 'developer', label: '관리자' },
        { value: 'reviewer', label: '리뷰어' }
    ];
    public groupManageTabs: any[] = [
        { value: 'info', label: '그룹 정보' },
        { value: 'members', label: '권한 관리' },
        { value: 'danger', label: '삭제' }
    ];
    public loadedRouteKey: string = '';
    private routeSubscription: any = null;
    private workspaceDetached: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  public router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/login');
        this.adminMode = this.routeAdminMode();
        this.loadedRouteKey = this.routeKey();
        this.routeSubscription = this.router.events.subscribe(async (event: any) => {
            if (event instanceof NavigationEnd) {
                await this.handleRouteChange(event.urlAfterRedirects || event.url || location.pathname);
            }
        });
        await this.load();
    }

    public ngOnDestroy() {
        if (this.routeSubscription && this.routeSubscription.unsubscribe) this.routeSubscription.unsubscribe();
        this.routeSubscription = null;
    }

    public reviewopsWorkspaceDetached() {
        this.workspaceDetached = true;
    }

    public reviewopsWorkspaceAttached() {
        this.workspaceDetached = false;
    }

    public routeAdminMode(path: string = `${location.pathname}${location.search}`) {
        try {
            const query = String(path || '').split('?')[1] || '';
            return new URLSearchParams(query).get('admin') === '1';
        } catch (e) {
            return false;
        }
    }

    public routeKey(path: string = `${location.pathname}${location.search}`) {
        const cleanPath = String(path || '').split('?')[0];
        return `${cleanPath}|${this.routeAdminMode(path) ? 'admin' : 'user'}`;
    }

    public async handleRouteChange(path: string = `${location.pathname}${location.search}`) {
        if (this.workspaceDetached) return;
        const nextKey = this.routeKey(path);
        if (!this.loadedRouteKey) {
            this.loadedRouteKey = nextKey;
            return;
        }
        if (nextKey === this.loadedRouteKey) {
            await this.service.render();
            return;
        }
        this.loadedRouteKey = nextKey;
        this.adminMode = this.routeAdminMode(path);
        this.showCreate = false;
        this.showCreateGroup = false;
        this.showGroupManage = false;
        this.memberUserOpen = false;
        this.tagFilterOpen = false;
        this.groupTagFilterOpen = false;
        this.mobileGroupActionsOpen = false;
        this.resetGroupPagination();
        this.resetProjectPagination();
        await this.load();
    }

    public requestParams(params: any = {}) {
        const query: any = Object.assign({}, params || {});
        if (this.adminMode) query.admin = '1';
        return query;
    }

    public blankForm() {
        return {
            project_type: 'web_service',
            name: '',
            link_url: '',
            description: '',
            labels: [],
            labelInput: '',
            document: null,
            status: 'active',
            default_viewport_width: 1440,
            default_viewport_height: 900,
            default_scale: 0.75,
            html_document_settings: this.defaultHtmlDocumentSettings(1440, 900)
        };
    }

    public defaultHtmlDocumentSettings(width: any = 1440, height: any = 900) {
        return {
            layout: {
                preset: 'web',
                render_mode: 'web',
                width: Number(width) || 1440,
                height: Number(height) || 900
            },
            instruction: {
                document_kind: 'proposal',
                audience: '',
                goal: '',
                tone: '',
                brand_rules: '',
                content_rules: '',
                harness_prompt: ''
            }
        };
    }

    public normalizeHtmlDocumentSettings(settings: any, width: any = 1440, height: any = 900) {
        const source = settings && typeof settings === 'object' ? settings : {};
        const defaults = this.defaultHtmlDocumentSettings(width, height);
        const layout = Object.assign({}, defaults.layout, source.layout || {});
        const instruction = Object.assign({}, defaults.instruction, source.instruction || {});
        layout.width = Math.min(Math.max(Number(layout.width) || Number(width) || 1440, 320), 7680);
        layout.height = Math.min(Math.max(Number(layout.height) || Number(height) || 900, 240), 7680);
        if (!['a4_portrait', 'a4_landscape', 'slide_16_9', 'slide_4_3', 'web', 'custom'].includes(layout.preset)) layout.preset = 'web';
        if (!['document', 'web'].includes(layout.render_mode)) layout.render_mode = 'web';
        return { layout, instruction };
    }

    public ensureHtmlDocumentSettings() {
        if (!this.form) this.form = {};
        if (!this.form.html_document_settings || !this.form.html_document_settings.layout || !this.form.html_document_settings.instruction) {
            this.form.html_document_settings = this.normalizeHtmlDocumentSettings(
                this.form.html_document_settings,
                this.form.default_viewport_width,
                this.form.default_viewport_height
            );
        }
        return this.form.html_document_settings;
    }

    public htmlDocumentLayout() {
        return this.ensureHtmlDocumentSettings().layout;
    }

    public blankGroupForm() {
        return {
            name: '',
            description: '',
            labels: [],
            labelInput: '',
            visibility: 'public',
            status: 'active'
        };
    }

    public toggleCreate() {
        if (!this.showingGroupProjects()) return;
        this.mobileGroupActionsOpen = false;
        this.showCreate = !this.showCreate;
        if (this.showCreate) {
            this.form = this.blankForm();
            this.documentUploadProgress = { visible: false, fileName: '', percent: 0, loaded: 0, total: 0, status: '', message: '' };
        }
        this.service.render();
    }

    public toggleCreateGroup() {
        this.mobileGroupActionsOpen = false;
        this.showCreateGroup = !this.showCreateGroup;
        if (this.showCreateGroup) this.groupForm = this.blankGroupForm();
        this.service.render();
    }

    public groupFormPayload(group: any) {
        return {
            name: group && group.name ? group.name : '',
            description: group && group.description ? group.description : '',
            labels: this.normalizeLabels(group && group.labels),
            labelInput: '',
            visibility: group && group.visibility ? group.visibility : 'public',
            status: group && group.status ? group.status : 'active'
        };
    }

    public calculateProjectStatusCounts() {
        const counts: any = { active: 0, archived: 0, disabled: 0, deleted: 0 };
        for (const project of this.projects) {
            const status = project && project.status ? project.status : 'active';
            if (counts[status] === undefined) counts[status] = 0;
            counts[status] += 1;
        }
        this.projectStatusCounts = counts;
    }

    public calculateGroupStatusCounts() {
        const counts: any = { active: 0, archived: 0, disabled: 0, deleted: 0 };
        for (const group of this.groups) {
            const status = group && group.status ? group.status : 'active';
            if (counts[status] === undefined) counts[status] = 0;
            counts[status] += 1;
        }
        this.groupStatusCounts = counts;
    }

    public async setGroupStatusFilter(value: string) {
        if (value === 'deleted' && !this.adminMode) value = 'active';
        this.groupStatusFilter = value || 'active';
        this.resetGroupPagination();
        await this.service.render();
    }

    public async setProjectStatusFilter(value: string) {
        if (value === 'deleted' && !this.adminMode) value = 'active';
        this.projectStatusFilter = value || 'active';
        this.resetProjectPagination();
        await this.service.render();
    }

    public async setProjectTypeFilter(value: string) {
        this.projectTypeFilter = value || 'all';
        this.resetProjectPagination();
        await this.service.render();
    }

    public async toggleProjectSort(field: string) {
        if (!['name', 'updated'].includes(field)) return;
        const [currentField, currentDirection] = this.normalizeProjectSort(this.projectSort).split('_');
        let direction = field === 'name' ? 'asc' : 'desc';
        if (currentField === field) direction = currentDirection === 'asc' ? 'desc' : 'asc';
        this.projectSort = `${field}_${direction}`;
        this.resetProjectPagination();
        await this.service.render();
    }

    public searchProjects() {
        this.resetGroupPagination();
        this.resetProjectPagination();
        this.service.render();
    }

    public selectedGroupId() {
        return this.groupIdFromPath();
    }

    public groupIdFromPath(path: string = location.pathname) {
        const cleanPath = String(path || '').split('?')[0];
        const match = cleanPath.match(/^\/projects(?:\/mine|\/participating)?\/group\/([^\/?#]+)/);
        return match ? decodeURIComponent(match[1]) : '';
    }

    public showingGroupProjects() {
        return !!this.selectedGroupId();
    }

    public groupPath(group: any) {
        return `/projects/mine/group/${group && group.id ? group.id : ''}`;
    }

    public groupQueryParams() {
        return this.adminMode ? { admin: '1' } : {};
    }

    public groupListPath() {
        if (this.adminMode) return '/admin';
        return '/projects/mine';
    }

    public groupListQueryParams() {
        return this.adminMode ? { tab: 'groups' } : {};
    }

    public currentGroupPath() {
        const groupId = this.selectedGroupId();
        if (!groupId) return this.groupListPath();
        const path = this.groupPath(this.selectedGroup || { id: groupId });
        return this.adminMode ? `${path}?admin=1` : path;
    }

    public projectDetailPath(project: any, tab: string = '') {
        const id = project && project.id ? project.id : '';
        if (!id) return '/projects/mine';
        return tab === 'review' ? `/projects/${id}/review` : `/projects/${id}`;
    }

    public projectDetailQueryParams() {
        return this.adminMode ? { admin: '1' } : {};
    }

    public rememberProjectReturn(project: any) {
        if (!project || !project.id || !this.showingGroupProjects()) return;
        try {
            const groupId = this.selectedGroupId();
            sessionStorage.setItem(`reviewops_project_return:${project.id}`, JSON.stringify({
                project_id: project.id,
                group_id: groupId,
                path: this.currentGroupPath(),
                saved_at: new Date().toISOString()
            }));
        } catch (e) { }
    }

    public canManageSelectedGroup() {
        return !!(this.selectedGroup && this.selectedGroup.can_manage_members);
    }

    public canEditSelectedGroupSettings() {
        return !!(this.selectedGroup && this.selectedGroup.can_edit_settings);
    }

    public canTransferSelectedGroupOwner() {
        return !!(this.selectedGroup && this.selectedGroup.can_transfer_owner);
    }

    public canDeleteSelectedGroup() {
        return !!(this.selectedGroup && this.selectedGroup.can_delete_group);
    }

    public canRestoreSelectedGroup() {
        return !!(this.selectedGroup && this.selectedGroup.can_restore_group);
    }

    public canLeaveSelectedGroup() {
        return !!(this.selectedGroup && this.selectedGroup.can_leave_group);
    }

    public canSubmitGroupDelete() {
        return this.canDeleteSelectedGroup() && String(this.groupDeleteConfirmName || '') === String(this.selectedGroup && this.selectedGroup.name || '');
    }

    public visibleGroupManageTabs() {
        return this.groupManageTabs.filter((tab: any) => {
            if (tab.value === 'info') return this.canEditSelectedGroupSettings();
            if (tab.value === 'danger') return this.canDeleteSelectedGroup() || this.canRestoreSelectedGroup();
            return true;
        });
    }

    public groupMemberAssignableRoleOptions() {
        if (this.canTransferSelectedGroupOwner()) return this.groupMemberRoleOptions;
        return this.groupMemberRoleOptions.filter((option: any) => option.value !== 'owner');
    }

    public groupMemberRoleOptionsFor(member: any) {
        if (member && member.group_role === 'owner') return this.groupMemberRoleOptions;
        return this.groupMemberAssignableRoleOptions();
    }

    public selectedGroupMembers() {
        return this.selectedGroup && Array.isArray(this.selectedGroup.members) ? this.selectedGroup.members : [];
    }

    public selectedGroupInvites() {
        return this.selectedGroup && Array.isArray(this.selectedGroup.invites) ? this.selectedGroup.invites : [];
    }

    public selectedGroupJoinRequests() {
        if (!this.canManageSelectedGroup()) return [];
        return this.selectedGroup && Array.isArray(this.selectedGroup.join_requests) ? this.selectedGroup.join_requests : [];
    }

    public joinRequestUserLabel(request: any) {
        const user = request && request.user ? request.user : {};
        return user.name || request.email || '-';
    }

    public groupMemberIds() {
        const ids: any = {};
        for (const member of this.selectedGroupMembers()) {
            if (member && member.id) ids[member.id] = true;
        }
        return ids;
    }

    public memberCandidateOptions() {
        const memberIds = this.groupMemberIds();
        return (this.userOptions || []).filter((user: any) => user && user.id && !memberIds[user.id]);
    }

    public filteredMemberCandidateOptions() {
        const query = String(this.memberForm.query || '').trim().toLowerCase();
        return this.memberCandidateOptions().filter((user: any) => {
            if (!query) return true;
            return this.userDisplay(user).toLowerCase().includes(query);
        });
    }

    public userDisplay(user: any) {
        if (!user) return '-';
        const name = user.display_name || user.name || user.email || '';
        const email = user.email && user.email !== name ? ` · ${user.email}` : '';
        return `${name}${email}`;
    }

    public normalizeEmail(value: any) {
        return String(value || '').trim().toLowerCase();
    }

    public validEmail(value: any) {
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this.normalizeEmail(value));
    }

    public memberFormEmail() {
        if (this.memberForm.user_id) {
            const selected = (this.userOptions || []).find((item: any) => item.id === this.memberForm.user_id);
            return this.normalizeEmail(selected && selected.email);
        }
        return this.normalizeEmail(this.memberForm.query);
    }

    public canSubmitGroupMember() {
        return !!this.memberForm.user_id || this.validEmail(this.memberFormEmail());
    }

    public groupHeaderActionCount() {
        if (!this.showingGroupProjects() || this.showGroupManage) return 0;
        let count = 0;
        if (this.canManageSelectedGroup()) count++;
        if (!this.loading && this.canLeaveSelectedGroup()) count++;
        if (this.projectCreationAllowed) count++;
        return count;
    }

    public toggleMobileGroupActions() {
        if (this.groupHeaderActionCount() < 3) {
            this.mobileGroupActionsOpen = false;
            this.service.render();
            return;
        }
        this.mobileGroupActionsOpen = !this.mobileGroupActionsOpen;
        this.service.render();
    }

    public closeMobileGroupActions() {
        if (!this.mobileGroupActionsOpen) return;
        this.mobileGroupActionsOpen = false;
        this.service.render();
    }

    public async setGroupManageTab(value: string) {
        this.groupManageTab = value || (this.canEditSelectedGroupSettings() ? 'info' : 'members');
        if (this.groupManageTab === 'info' && !this.canEditSelectedGroupSettings()) this.groupManageTab = 'members';
        if (this.groupManageTab === 'danger' && !this.canDeleteSelectedGroup() && !this.canRestoreSelectedGroup()) this.groupManageTab = 'members';
        await this.service.render();
    }

    public groupManageTabClass(value: string) {
        const selected = this.groupManageTab === value;
        const base = 'inline-flex h-10 items-center justify-center border-b-2 px-3 text-[13px] font-semibold transition-colors';
        if (selected) return `${base} border-slate-950 text-slate-950`;
        return `${base} border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-900`;
    }

    public openMemberUserPicker() {
        this.memberUserOpen = true;
        this.service.render();
    }

    public async searchMemberCandidates() {
        this.memberForm.user_id = '';
        this.memberUserOpen = true;
        await this.service.render();
        await this.loadUserOptions(this.memberForm.query || '');
    }

    public closeMemberUserPickerLater() {
        window.setTimeout(async () => {
            this.memberUserOpen = false;
            await this.service.render();
        }, 120);
    }

    public selectMemberCandidate(user: any) {
        if (!user || !user.id) return;
        this.memberForm.user_id = user.id;
        this.memberForm.query = this.userDisplay(user);
        this.memberUserOpen = false;
        this.service.render();
    }

    public async openGroupManage() {
        if (!this.canManageSelectedGroup()) return;
        this.mobileGroupActionsOpen = false;
        this.groupForm = this.groupFormPayload(this.selectedGroup);
        this.memberForm = { user_id: '', query: '', role: 'reviewer' };
        this.groupDeleteConfirmName = '';
        this.memberUserOpen = false;
        this.groupManageTab = this.canEditSelectedGroupSettings() ? 'info' : 'members';
        this.showCreate = false;
        this.showCreateGroup = false;
        this.showGroupManage = true;
        await this.service.render();
        await this.loadUserOptions();
    }

    public async closeGroupManage() {
        this.mobileGroupActionsOpen = false;
        this.showGroupManage = false;
        this.groupManageTab = 'info';
        this.groupDeleteConfirmName = '';
        this.memberForm = { user_id: '', query: '', role: 'reviewer' };
        this.memberUserOpen = false;
        await this.service.render();
    }

    public applySelectedGroup(group: any) {
        if (!group) return;
        this.selectedGroup = group;
        this.groupForm = this.groupFormPayload(group);
        const index = this.groups.findIndex((item) => item.id === group.id);
        if (index >= 0) this.groups[index] = Object.assign({}, this.groups[index], group);
        this.calculateGroupStatusCounts();
        this.ensureGroupPage();
    }

    public async loadUserOptions(text: string = '') {
        this.loadingUserOptions = true;
        const { code, data } = await wiz.call('load_user_options', this.requestParams({ text }));
        this.loadingUserOptions = false;
        if (code === 200) this.userOptions = data.users || [];
        await this.service.render();
    }

    public filteredGroups() {
        const status = this.groupStatusFilter || 'active';
        const text = String(this.filters.text || '').trim().toLowerCase();
        const label = String(this.filters.group_label || '').trim().toLowerCase();
        return this.groups.filter((group) => {
            const groupStatus = group && group.status ? group.status : 'active';
            if (groupStatus !== status) return false;
            if (label && !this.groupLabels(group).some((item) => item.toLowerCase() === label)) return false;
            if (!text) return true;
            return this.groupMatchesSearch(group, text);
        });
    }

    public visibleGroups() {
        const rows = this.filteredGroups();
        const start = (this.groupPage - 1) * this.groupPageSize;
        return rows.slice(start, start + this.groupPageSize);
    }

    public groupTotalCount() {
        return this.filteredGroups().length;
    }

    public groupTotalPages() {
        const total = Math.ceil(this.groupTotalCount() / this.groupPageSize);
        return Math.max(total || 1, 1);
    }

    public groupPageStart() {
        const total = this.groupTotalCount();
        if (!total) return 0;
        return (this.groupPage - 1) * this.groupPageSize + 1;
    }

    public groupPageEnd() {
        return Math.min(this.groupPage * this.groupPageSize, this.groupTotalCount());
    }

    public groupPageNumbers() {
        const total = this.groupTotalPages();
        const current = Math.min(Math.max(this.groupPage, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public setGroupPage(page: number) {
        const total = this.groupTotalPages();
        const next = Math.min(Math.max(Number(page) || 1, 1), total);
        if (this.groupPage === next) return;
        this.groupPage = next;
        this.service.render();
    }

    public resetGroupPagination() {
        this.groupPage = 1;
    }

    public ensureGroupPage() {
        this.setGroupPage(this.groupPage);
    }

    public groupStatusBadgeClass(value: string) {
        if (value === 'private') return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-slate-900 px-2 py-0.5 text-[11px] font-medium text-white';
        return 'inline-flex shrink-0 whitespace-nowrap rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
    }

    public groupEmptyMessage() {
        if (String(this.filters.text || '').trim() || String(this.filters.group_label || '').trim()) return '검색 결과가 없습니다.';
        if (!this.groups.length) return '소유자/관리자 권한이 있는 그룹이 없습니다.';
        return `${this.projectStatusLabel(this.groupStatusFilter)} 그룹이 없습니다.`;
    }

    public groupMatchesSearch(group: any, text: string) {
        const owner = group && group.owner ? group.owner : {};
        const haystack = [
            group && group.name,
            group && group.description,
            this.groupLabels(group).join(' '),
            group && group.visibility,
            group && group.status,
            this.projectStatusLabel(group && group.status ? group.status : 'active'),
            owner.name,
            owner.email,
            this.roleLabel(group && group.group_role)
        ].join(' ').toLowerCase();
        return haystack.indexOf(text) >= 0;
    }

    public filteredProjects() {
        const text = String(this.filters.text || '').trim().toLowerCase();
        const label = String(this.filters.label || '').trim().toLowerCase();
        const type = this.projectTypeFilter || 'all';
        return this.projects.filter((project) => {
            const status = project && project.status ? project.status : 'active';
            if (status !== this.projectStatusFilter) return false;
            if (type !== 'all' && this.projectTypeValue(project) !== type) return false;
            if (label && !this.projectLabels(project).some((item) => item.toLowerCase() === label)) return false;
            if (!text) return true;
            return this.projectMatchesSearch(project, text);
        });
    }

    public projectTypeValue(project: any) {
        return project && project.project_type ? String(project.project_type) : 'web_service';
    }

    public normalizeProjectSort(value: any) {
        const candidate = String(value || '').trim();
        return ['name_asc', 'name_desc', 'updated_asc', 'updated_desc'].includes(candidate) ? candidate : 'name_asc';
    }

    public projectSortHeaderClass(field: string, compact: boolean = false) {
        const active = this.normalizeProjectSort(this.projectSort).startsWith(`${field}_`);
        const base = compact
            ? 'inline-flex h-9 items-center gap-1.5 border-r border-slate-200 px-3 text-[12px] font-semibold transition-colors last:border-r-0 '
            : 'inline-flex items-center gap-1 whitespace-nowrap rounded px-1 py-0.5 text-[12px] font-semibold transition-colors ';
        if (active) return base + 'bg-slate-100 text-slate-950';
        return base + 'text-slate-500 hover:bg-slate-100 hover:text-slate-900';
    }

    public projectSortIconClass(field: string) {
        const [currentField, direction] = this.normalizeProjectSort(this.projectSort).split('_');
        if (currentField !== field) return 'fa-solid fa-sort text-[10px] text-slate-300';
        if (direction === 'desc') return 'fa-solid fa-chevron-down text-[10px] text-slate-700';
        return 'fa-solid fa-chevron-up text-[10px] text-slate-700';
    }

    public projectSortHeaderTitle(field: string) {
        const label = field === 'updated' ? '최근 업데이트' : '프로젝트명';
        const [currentField, direction] = this.normalizeProjectSort(this.projectSort).split('_');
        if (currentField !== field) return `${label} ${field === 'updated' ? '내림차순' : '오름차순'} 정렬`;
        return `${label} ${direction === 'asc' ? '내림차순' : '오름차순'} 정렬`;
    }

    public projectSortAriaValue(field: string) {
        const [currentField, direction] = this.normalizeProjectSort(this.projectSort).split('_');
        if (currentField !== field) return 'none';
        return direction === 'asc' ? 'ascending' : 'descending';
    }

    public projectNameSortValue(project: any) {
        return String(project && project.name ? project.name : '').trim().normalize('NFC');
    }

    public projectUpdatedSortValue(project: any) {
        const value = project && (project.updated || project.updated_at || project.created || project.created_at);
        if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
        const text = String(value || '').trim();
        if (!text) return 0;
        const timestamp = Date.parse(text.indexOf('T') >= 0 ? text : text.replace(' ', 'T'));
        return Number.isFinite(timestamp) ? timestamp : 0;
    }

    public projectUpdatedLabel(project: any) {
        const timestamp = this.projectUpdatedSortValue(project);
        if (!timestamp) return '-';
        const date = new Date(timestamp);
        const pad = (value: number) => String(value).padStart(2, '0');
        return `${date.getFullYear()}.${pad(date.getMonth() + 1)}.${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    }

    public sortedProjects() {
        const sort = this.normalizeProjectSort(this.projectSort);
        const [field, direction] = sort.split('_');
        const multiplier = direction === 'asc' ? 1 : -1;
        return this.filteredProjects()
            .map((project, index) => ({ project, index }))
            .sort((left, right) => {
                let comparison = 0;
                if (field === 'name') {
                    comparison = this.projectNameSortValue(left.project).localeCompare(
                        this.projectNameSortValue(right.project),
                        'ko-KR',
                        { numeric: true, sensitivity: 'base' },
                    );
                } else {
                    const leftUpdated = this.projectUpdatedSortValue(left.project);
                    const rightUpdated = this.projectUpdatedSortValue(right.project);
                    if (!leftUpdated || !rightUpdated) {
                        if (leftUpdated !== rightUpdated) return leftUpdated ? -1 : 1;
                    } else {
                        comparison = leftUpdated - rightUpdated;
                    }
                }
                return comparison === 0 ? left.index - right.index : comparison * multiplier;
            })
            .map((item) => item.project);
    }

    public visibleProjects() {
        const rows = this.sortedProjects();
        const start = (this.projectPage - 1) * this.projectPageSize;
        return rows.slice(start, start + this.projectPageSize);
    }

    public projectMatchesSearch(project: any, text: string) {
        const owner = project && project.owner ? project.owner : {};
        const haystack = [
            project && project.name,
            project && project.description,
            project && project.link_url,
            project && project.project_type_label,
            project && project.visibility,
            this.projectLabels(project).join(' '),
            owner.name,
            owner.email
        ].join(' ').toLowerCase();
        return haystack.indexOf(text) >= 0;
    }

    public projectLabels(project: any) {
        return this.normalizeLabels(project && project.labels);
    }

    public groupLabels(group: any) {
        return this.normalizeLabels(group && group.labels);
    }

    public groupLabelOptions() {
        const labels: string[] = [];
        const seen: any = {};
        for (const group of this.groups) {
            for (const label of this.groupLabels(group)) {
                const value = String(label || '').trim();
                const key = value.toLowerCase();
                if (!value || seen[key]) continue;
                seen[key] = true;
                labels.push(value);
            }
        }
        return labels.sort((a, b) => a.localeCompare(b));
    }

    public filteredGroupLabelOptions() {
        const query = String(this.groupTagFilterQuery || '').trim().toLowerCase();
        return this.groupLabelOptions().filter((label) => !query || label.toLowerCase().includes(query));
    }

    public openGroupLabelFilter() {
        this.groupTagFilterOpen = true;
        this.service.render();
    }

    public closeGroupLabelFilterLater() {
        window.setTimeout(async () => {
            this.groupTagFilterOpen = false;
            await this.service.render();
        }, 120);
    }

    public async selectGroupLabelFilter(label: string) {
        this.filters.group_label = label || '';
        this.groupTagFilterQuery = this.filters.group_label;
        this.groupTagFilterOpen = false;
        this.resetGroupPagination();
        await this.service.render();
    }

    public async selectFirstGroupLabelFilter() {
        const options = this.filteredGroupLabelOptions();
        if (options.length) await this.selectGroupLabelFilter(options[0]);
    }

    public async clearGroupLabelFilter() {
        this.filters.group_label = '';
        this.groupTagFilterQuery = '';
        this.groupTagFilterOpen = false;
        this.resetGroupPagination();
        await this.service.render();
    }

    public labelOptions() {
        const labels: string[] = [];
        const seen: any = {};
        for (const project of this.projects) {
            for (const label of this.projectLabels(project)) {
                const value = String(label || '').trim();
                const key = value.toLowerCase();
                if (!value || seen[key]) continue;
                seen[key] = true;
                labels.push(value);
            }
        }
        return labels.sort((a, b) => a.localeCompare(b));
    }

    public filteredLabelOptions() {
        const query = String(this.tagFilterQuery || '').trim().toLowerCase();
        return this.labelOptions().filter((label) => !query || label.toLowerCase().includes(query));
    }

    public openLabelFilter() {
        this.tagFilterOpen = true;
        this.service.render();
    }

    public closeLabelFilterLater() {
        window.setTimeout(async () => {
            this.tagFilterOpen = false;
            await this.service.render();
        }, 120);
    }

    public selectLabelFilter(label: string) {
        this.filters.label = label || '';
        this.tagFilterQuery = this.filters.label;
        this.tagFilterOpen = false;
        this.resetProjectPagination();
        this.service.render();
    }

    public selectFirstLabelFilter() {
        const options = this.filteredLabelOptions();
        if (options.length) this.selectLabelFilter(options[0]);
    }

    public clearLabelFilter() {
        this.filters.label = '';
        this.tagFilterQuery = '';
        this.tagFilterOpen = false;
        this.resetProjectPagination();
        this.service.render();
    }

    public projectTotalCount() {
        return this.filteredProjects().length;
    }

    public projectTotalPages() {
        const total = Math.ceil(this.projectTotalCount() / this.projectPageSize);
        return Math.max(total || 1, 1);
    }

    public projectPageStart() {
        const total = this.projectTotalCount();
        if (!total) return 0;
        return (this.projectPage - 1) * this.projectPageSize + 1;
    }

    public projectPageEnd() {
        return Math.min(this.projectPage * this.projectPageSize, this.projectTotalCount());
    }

    public projectPageNumbers() {
        const total = this.projectTotalPages();
        const current = Math.min(Math.max(this.projectPage, 1), total);
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public setProjectPage(page: number) {
        const total = this.projectTotalPages();
        const next = Math.min(Math.max(Number(page) || 1, 1), total);
        if (this.projectPage === next) return;
        this.projectPage = next;
        this.service.render();
    }

    public resetProjectPagination() {
        this.projectPage = 1;
    }

    public ensureProjectPage() {
        this.setProjectPage(this.projectPage);
    }

    public statusTabClass(value: string) {
        const selected = this.projectStatusFilter === value;
        const base = 'reviewops-header-control inline-flex h-9 items-center justify-center gap-1.5 border-r border-slate-200 px-3 text-[12px] font-semibold transition-colors last:border-r-0';
        if (selected) return `${base} bg-slate-900 text-white`;
        return `${base} bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950`;
    }

    public groupStatusTabClass(value: string) {
        const selected = this.groupStatusFilter === value;
        const base = 'reviewops-header-control inline-flex h-9 items-center justify-center gap-1.5 border-r border-slate-200 px-3 text-[12px] font-semibold transition-colors last:border-r-0';
        if (selected) return `${base} bg-slate-900 text-white`;
        return `${base} bg-white text-slate-600 hover:bg-slate-50 hover:text-slate-950`;
    }

    public projectTypeFilterTabClass(value: string) {
        const selected = this.projectTypeFilter === value;
        const base = 'inline-flex h-10 items-center justify-center border-b-2 px-3 text-[13px] font-semibold transition-colors';
        if (selected) return `${base} border-slate-950 text-slate-950`;
        return `${base} border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-900`;
    }

    public projectStatusBadgeClass(value: string) {
        const status = value || 'active';
        if (status === 'deleted') return 'rounded-full bg-rose-50 px-2 py-0.5 text-[11px] font-medium text-rose-700';
        if (status === 'archived') return 'rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700';
        if (status === 'disabled') return 'rounded-full bg-slate-200 px-2 py-0.5 text-[11px] font-medium text-slate-600';
        return 'rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
    }

    public statusFilterOptions() {
        if (!this.adminMode) return this.projectStatusOptions;
        return this.projectStatusOptions.concat([{ value: 'deleted', label: '삭제', description: '삭제 상태' }]);
    }

    public projectStatusEmptyMessage() {
        if (String(this.filters.text || '').trim() || String(this.filters.label || '').trim()) return '검색 결과가 없습니다.';
        return `${this.projectStatusLabel(this.projectStatusFilter)} 프로젝트가 없습니다.`;
    }

    public async load() {
        this.loading = true;
        this.groups = [];
        this.projects = [];
        this.calculateGroupStatusCounts();
        this.calculateProjectStatusCounts();
        await this.service.render();

        const { code, data } = await wiz.call('load', this.requestParams({
            group_id: this.selectedGroupId(),
            text: this.filters.text || '',
            group_label: this.filters.group_label || '',
            project_text: this.filters.text || '',
            status: '',
            label: this.filters.label || ''
        }));
        if (code === 200) {
            this.applyUploadSettings(data.upload_settings);
            this.projectCatalogAllowed = data.can_use_project_catalog !== false;
            this.projectCreationAllowed = data.can_create_project_catalog === true;
            if (!this.projectCatalogAllowed) {
                location.href = '/projects/participating';
                return;
            }
            this.groups = data.groups || [];
            this.selectedGroup = data.group || null;
            this.groupForm = this.groupFormPayload(this.selectedGroup || {});
            this.projects = data.projects || [];
            this.calculateGroupStatusCounts();
            this.calculateProjectStatusCounts();
            this.ensureGroupPage();
            this.ensureProjectPage();
            if (!this.selectedGroup) {
                this.showGroupManage = false;
                this.groupManageTab = 'info';
            }
            if (this.showGroupManage && this.groupManageTab === 'info' && !this.canEditSelectedGroupSettings()) {
                this.groupManageTab = 'members';
            }
        }

        this.loading = false;
        await this.service.render();
    }

    public async createProject() {
        if (!this.projectCreationAllowed) {
            await this.service.modal.error('프로젝트 등록 권한이 없습니다.');
            return;
        }
        if (!this.selectedGroupId()) {
            await this.service.modal.error('프로젝트를 등록할 그룹을 먼저 선택해주세요.');
            return;
        }
        if (this.isDocumentType(this.form.project_type) && !this.form.document) {
            await this.service.modal.error('PDF 프로젝트는 PDF 업로드가 필요합니다.');
            return;
        }
        this.saving = true;
        await this.service.render();

        this.addFormLabel();
        const payload = Object.assign({}, this.form, { labels: this.normalizeLabels(this.form.labels) });
        if (this.isHtmlProject()) {
            payload.html_document_settings = this.normalizeHtmlDocumentSettings(
                this.form.html_document_settings,
                this.form.default_viewport_width,
                this.form.default_viewport_height
            );
            payload.default_viewport_width = payload.html_document_settings.layout.width;
            payload.default_viewport_height = payload.html_document_settings.layout.height;
        } else {
            delete payload.html_document_settings;
        }
        if (this.selectedGroupId()) payload.group_id = this.selectedGroupId();
        delete payload.labelInput;
        const { code, data } = await this.submitCreateProject(payload);
        this.saving = false;
        if (code === 200) {
            this.showCreate = false;
            await this.load();
            return;
        }

        await this.service.modal.error(data.message || '프로젝트를 저장하지 못했습니다.');
        await this.service.render();
    }

    public async createGroup() {
        if (!this.projectCreationAllowed) {
            await this.service.modal.error('그룹 생성 권한이 없습니다.');
            return;
        }
        const name = String(this.groupForm.name || '').trim();
        if (!name) {
            await this.service.modal.error('그룹명을 입력해주세요.');
            return;
        }
        this.savingGroup = true;
        await this.service.render();
        this.addGroupFormLabel();
        const payload = Object.assign({}, this.groupForm, { name, labels: this.normalizeLabels(this.groupForm.labels) });
        delete payload.labelInput;
        const { code, data } = await wiz.call('create_group', { data: JSON.stringify(payload) });
        this.savingGroup = false;
        if (code === 200) {
            this.showCreateGroup = false;
            const group = data.group || {};
            if (group.id) {
                location.href = `/projects/mine/group/${group.id}`;
                return;
            }
            await this.load();
        } else {
            await this.service.modal.error(data.message || '그룹을 생성하지 못했습니다.');
        }
        await this.service.render();
    }

    public async saveGroupSettings() {
        if (!this.canManageSelectedGroup()) return;
        const name = String(this.groupForm.name || '').trim();
        if (!name) {
            await this.service.modal.error('그룹명을 입력해주세요.');
            return;
        }
        this.savingGroupSettings = true;
        await this.service.render();
        this.addGroupFormLabel();
        const payload = Object.assign({}, this.groupForm, { name, labels: this.normalizeLabels(this.groupForm.labels) });
        delete payload.labelInput;
        const { code, data } = await wiz.call('save_group', this.requestParams({
            group_id: this.selectedGroupId(),
            data: JSON.stringify(payload)
        }));
        this.savingGroupSettings = false;
        if (code === 200) {
            this.applySelectedGroup(data.group);
            await this.service.modal.success('그룹 정보가 저장되었습니다.');
        } else {
            await this.service.modal.error(data.message || '그룹 정보를 저장하지 못했습니다.');
        }
        await this.service.render();
    }

    public async deleteGroup() {
        if (!this.canSubmitGroupDelete()) {
            await this.service.modal.error('삭제할 그룹명을 정확히 입력해주세요.');
            return;
        }
        const ok = await this.service.modal.show({
            title: '그룹 삭제',
            message: `${this.selectedGroup.name} 그룹을 삭제 상태로 전환합니다. 일반 사용자 화면에서는 이 그룹과 하위 프로젝트가 보이지 않습니다.`,
            action: '삭제',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!ok) return;
        this.deletingGroup = true;
        await this.service.render();
        const { code, data } = await wiz.call('delete_group', this.requestParams({
            group_id: this.selectedGroupId()
        }));
        this.deletingGroup = false;
        if (code === 200) {
            if (this.adminMode && data.group) {
                this.applySelectedGroup(data.group);
                this.groupDeleteConfirmName = '';
                this.groupManageTab = 'danger';
                await this.service.modal.success('그룹을 삭제 상태로 전환했습니다.');
            } else {
                await this.service.modal.success('그룹을 삭제 상태로 전환했습니다.');
                location.href = this.groupListPath();
                return;
            }
        } else {
            await this.service.modal.error(data.message || '그룹을 삭제하지 못했습니다.');
        }
        await this.service.render();
    }

    public async restoreGroup() {
        if (!this.canRestoreSelectedGroup()) return;
        const ok = await this.service.modal.show({
            title: '그룹 복원',
            message: `${this.selectedGroup.name} 그룹을 활성 상태로 복원할까요?`,
            action: '복원',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.restoringGroup = true;
        await this.service.render();
        const { code, data } = await wiz.call('restore_group', this.requestParams({
            group_id: this.selectedGroupId()
        }));
        this.restoringGroup = false;
        if (code === 200) {
            this.applySelectedGroup(data.group);
            this.groupManageTab = 'info';
            await this.service.modal.success('그룹을 복원했습니다.');
        } else {
            await this.service.modal.error(data.message || '그룹을 복원하지 못했습니다.');
        }
        await this.service.render();
    }

    public async addGroupMember() {
        if (!this.canManageSelectedGroup()) return;
        const inviteEmail = this.memberFormEmail();
        if (!this.canSubmitGroupMember()) {
            await this.service.modal.error('사용자를 선택하거나 올바른 이메일을 입력해주세요.');
            return;
        }
        if (this.memberForm.role === 'owner') {
            if (!this.memberForm.user_id) {
                await this.service.modal.error('소유자는 가입된 사용자만 지정할 수 있습니다.');
                return;
            }
            if (!this.canTransferSelectedGroupOwner()) {
                await this.service.modal.error('소유자 지정 권한이 없습니다.');
                return;
            }
            const target = (this.userOptions || []).find((item: any) => item.id === this.memberForm.user_id);
            const ok = await this.service.modal.show({
                title: '소유자 지정',
                message: `${this.userDisplay(target)} 사용자를 그룹 소유자로 지정할까요? 기존 소유자는 관리자 구성원으로 남습니다.`,
                action: '지정',
                cancel: '취소',
                status: 'warning',
                actionBtn: 'warning'
            });
            if (!ok) return;
        }
        this.savingGroupMember = true;
        await this.service.render();
        const { code, data } = await wiz.call('add_group_member', this.requestParams({
            group_id: this.selectedGroupId(),
            data: JSON.stringify({
                user_id: this.memberForm.user_id || '',
                email: this.memberForm.user_id ? '' : inviteEmail,
                role: this.memberForm.role || 'reviewer'
            })
        }));
        this.savingGroupMember = false;
        if (code === 200) {
            this.applySelectedGroup(data.group);
            this.memberForm = { user_id: '', query: '', role: 'reviewer' };
            this.memberUserOpen = false;
        } else {
            await this.service.modal.error(data.message || '구성원을 추가하지 못했습니다.');
        }
        await this.service.render();
    }

    public async changeGroupMemberRole(member: any, role: string) {
        if (!this.canManageSelectedGroup() || !member || !role || role === member.group_role) return;
        if (member.group_role === 'owner') return;
        if (role === 'owner') {
            if (!this.canTransferSelectedGroupOwner()) {
                await this.service.modal.error('소유자 지정 권한이 없습니다.');
                await this.service.render();
                return;
            }
            const ok = await this.service.modal.show({
                title: '소유자 지정',
                message: `${member.name || member.email} 님을 그룹 소유자로 지정할까요? 기존 소유자는 관리자 구성원으로 남습니다.`,
                action: '지정',
                cancel: '취소',
                status: 'warning',
                actionBtn: 'warning'
            });
            if (!ok) return;
        }
        this.savingGroupRoleId = member.id;
        await this.service.render();
        const { code, data } = await wiz.call('update_group_member', this.requestParams({
            group_id: this.selectedGroupId(),
            user_id: member.id,
            data: JSON.stringify({ role })
        }));
        this.savingGroupRoleId = '';
        if (code === 200) {
            this.applySelectedGroup(data.group);
        } else {
            await this.service.modal.error(data.message || '구성원 권한을 변경하지 못했습니다.');
        }
        await this.service.render();
    }

    public async removeGroupMember(member: any) {
        if (!this.canManageSelectedGroup() || !member || member.group_role === 'owner') return;
        const ok = await this.service.modal.show({
            title: '구성원 제거',
            message: `${member.name || member.email} 님을 그룹 구성원에서 제거할까요?`,
            action: '제거',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        const { code, data } = await wiz.call('remove_group_member', this.requestParams({
            group_id: this.selectedGroupId(),
            user_id: member.id
        }));
        if (code === 200) {
            this.applySelectedGroup(data.group);
        } else {
            await this.service.modal.error(data.message || '구성원을 제거하지 못했습니다.');
        }
        await this.service.render();
    }

    public async approveJoinRequest(request: any) {
        if (!this.canManageSelectedGroup() || !request || !request.id || this.approvingJoinRequestId) return;
        this.approvingJoinRequestId = request.id;
        await this.service.render();
        const { code, data } = await wiz.call('approve_group_join_request', this.requestParams({
            group_id: this.selectedGroupId(),
            request_id: request.id
        }));
        this.approvingJoinRequestId = '';
        if (code === 200) {
            this.applySelectedGroup(data.group);
            await this.service.modal.success('가입 신청을 승인했습니다.');
        } else {
            await this.service.modal.error(data.message || '가입 신청을 승인하지 못했습니다.');
        }
        await this.service.render();
    }

    public async rejectJoinRequest(request: any) {
        if (!this.canManageSelectedGroup() || !request || !request.id || this.rejectingJoinRequestId) return;
        const ok = await this.service.modal.show({
            title: '가입 신청 거절',
            message: `${this.joinRequestUserLabel(request)} 님의 가입 신청을 거절할까요?`,
            action: '거절',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.rejectingJoinRequestId = request.id;
        await this.service.render();
        const { code, data } = await wiz.call('reject_group_join_request', this.requestParams({
            group_id: this.selectedGroupId(),
            request_id: request.id
        }));
        this.rejectingJoinRequestId = '';
        if (code === 200) {
            this.applySelectedGroup(data.group);
        } else {
            await this.service.modal.error(data.message || '가입 신청을 거절하지 못했습니다.');
        }
        await this.service.render();
    }

    public async leaveGroup() {
        if (!this.canLeaveSelectedGroup() || this.leavingGroup) return;
        const ok = await this.service.modal.show({
            title: '그룹 탈퇴',
            message: `${this.selectedGroup.name} 그룹에서 탈퇴할까요?`,
            action: '탈퇴',
            cancel: '취소',
            status: 'error',
            actionBtn: 'error'
        });
        if (!ok) return;
        this.leavingGroup = true;
        await this.service.render();
        const { code, data } = await wiz.call('leave_group', this.requestParams({
            group_id: this.selectedGroupId()
        }));
        this.leavingGroup = false;
        if (code === 200) {
            await this.service.modal.success('그룹에서 탈퇴했습니다.');
            location.href = this.groupListPath();
            return;
        }
        await this.service.modal.error(data.message || '그룹을 탈퇴하지 못했습니다.');
        await this.service.render();
    }

    public async sendGroupInviteEmail(invite: any) {
        if (!this.canManageSelectedGroup() || !invite || !invite.id) return;
        this.sendingGroupInviteId = invite.id;
        await this.service.render();
        const { code, data } = await wiz.call('send_group_invite_email', this.requestParams({
            group_id: this.selectedGroupId(),
            invite_id: invite.id
        }));
        this.sendingGroupInviteId = '';
        if (code === 200) {
            this.applySelectedGroup(data.group);
            await this.service.modal.success('초대 이메일을 발송했습니다.');
        } else {
            await this.service.modal.error(data.message || '초대 이메일을 발송하지 못했습니다.');
        }
        await this.service.render();
    }

    public async removeGroupInvite(invite: any) {
        if (!this.canManageSelectedGroup() || !invite || !invite.id) return;
        const ok = await this.service.modal.show({
            title: '사전 초대 취소',
            message: `${invite.email} 초대를 취소할까요?`,
            action: '취소',
            cancel: '닫기',
            status: 'warning',
            actionBtn: 'warning'
        });
        if (!ok) return;
        this.removingGroupInviteId = invite.id;
        await this.service.render();
        const { code, data } = await wiz.call('remove_group_invite', this.requestParams({
            group_id: this.selectedGroupId(),
            invite_id: invite.id
        }));
        this.removingGroupInviteId = '';
        if (code === 200) {
            this.applySelectedGroup(data.group);
        } else {
            await this.service.modal.error(data.message || '초대를 취소하지 못했습니다.');
        }
        await this.service.render();
    }

    public roleLabel(role: string) {
        const labels: any = {
            owner: '소유자',
            developer: '관리자',
            reviewer: '리뷰어'
        };
        return labels[role || 'owner'] || role;
    }

    public isDocumentType(type: string) {
        return ['pdf', 'pdf_document', 'pdf_presentation', 'proposal', 'presentation'].includes(type || '');
    }

    public isWebProject() {
        return this.form.project_type === 'web_service';
    }

    public isHtmlProject() {
        return this.form.project_type === 'html';
    }

    public setProjectType(value: string) {
        this.form.project_type = value;
        if (!this.isDocumentType(value)) this.form.document = null;
        if (value === 'html') {
            const settings = this.ensureHtmlDocumentSettings();
            this.form.default_viewport_width = settings.layout.width;
            this.form.default_viewport_height = settings.layout.height;
        }
        this.service.render();
    }

    public labelCandidates(value: any): string[] {
        if (value === null || value === undefined) return [];
        if (Array.isArray(value)) {
            let result: string[] = [];
            for (const item of value) result = result.concat(this.labelCandidates(item));
            return result;
        }
        if (typeof value === 'object') {
            for (const key of ['value', 'label', 'text', 'title', 'name']) {
                if (value[key] !== null && value[key] !== undefined) return this.labelCandidates(value[key]);
            }
            return [];
        }
        const text = String(value).trim();
        if (text.startsWith('[') || text.startsWith('{')) {
            try {
                return this.labelCandidates(JSON.parse(text));
            } catch (e) { }
        }
        return [text];
    }

    public normalizeLabel(value: any) {
        const candidates = this.labelCandidates(value);
        let label = String(candidates.length ? candidates[0] : '').trim().replace(/^#+/, '').trim();
        while (label.indexOf('  ') >= 0) label = label.replace(/  /g, ' ');
        const key = label.toLowerCase();
        if (key === 'object' || key === '[object object]') return '';
        return label.slice(0, 40);
    }

    public normalizeLabels(labels: any) {
        let source = labels;
        if (typeof labels === 'string') {
            const text = labels.trim();
            source = text.startsWith('[') || text.startsWith('{') ? labels : text.replace(/\n/g, ',').split(',');
        }
        const result: string[] = [];
        const seen: any = {};
        for (const value of this.labelCandidates(source)) {
            const label = this.normalizeLabel(value);
            const key = label.toLowerCase();
            if (!label || key === 'object' || key === '[object object]' || seen[key]) continue;
            seen[key] = true;
            result.push(label);
            if (result.length >= 12) break;
        }
        return result;
    }

    public labelEventComposing(event: any) {
        const source = event && (event.originalEvent || event.nativeEvent || event);
        return !!(source && (source.isComposing || source.keyCode === 229 || source.which === 229));
    }

    public labelEventValue(event: any, fallback: any) {
        const target = event && event.target;
        if (target && typeof target.value === 'string') return target.value;
        return fallback;
    }

    public clearLabelEventValue(event: any) {
        const target = event && event.target;
        if (target && typeof target.value === 'string') target.value = '';
    }

    public addFormLabel(value?: any) {
        const label = this.normalizeLabel(value !== undefined ? value : this.form.labelInput);
        if (!label) return false;
        this.form.labels = this.normalizeLabels([...(this.form.labels || []), label]);
        this.form.labelInput = '';
        this.service.render();
        return true;
    }

    public removeFormLabel(label: string) {
        const key = String(label || '').toLowerCase();
        this.form.labels = this.normalizeLabels(this.form.labels).filter((item) => item.toLowerCase() !== key);
        this.service.render();
    }

    public handleFormLabelKeydown(event: any) {
        if (!event || !['Enter', ','].includes(event.key)) return;
        if (this.labelEventComposing(event)) return;
        event.preventDefault();
        if (event.key === ',' && this.addFormLabel(this.labelEventValue(event, this.form.labelInput))) {
            this.clearLabelEventValue(event);
        }
    }

    public handleFormLabelKeyup(event: any) {
        if (!event || event.key !== 'Enter') return;
        if (this.labelEventComposing(event)) return;
        event.preventDefault();
        if (this.addFormLabel(this.labelEventValue(event, this.form.labelInput))) {
            this.clearLabelEventValue(event);
        }
    }

    public addGroupFormLabel(value?: any) {
        const label = this.normalizeLabel(value !== undefined ? value : this.groupForm.labelInput);
        if (!label) return false;
        this.groupForm.labels = this.normalizeLabels([...(this.groupForm.labels || []), label]);
        this.groupForm.labelInput = '';
        this.service.render();
        return true;
    }

    public removeGroupFormLabel(label: string) {
        const key = String(label || '').toLowerCase();
        this.groupForm.labels = this.normalizeLabels(this.groupForm.labels).filter((item) => item.toLowerCase() !== key);
        this.service.render();
    }

    public async setGroupFormOption(key: string, value: string) {
        this.groupForm[key] = value;
        await this.service.render();
    }

    public handleGroupFormLabelKeydown(event: any) {
        if (!event || !['Enter', ','].includes(event.key)) return;
        if (this.labelEventComposing(event)) return;
        event.preventDefault();
        if (event.key === ',' && this.addGroupFormLabel(this.labelEventValue(event, this.groupForm.labelInput))) {
            this.clearLabelEventValue(event);
        }
    }

    public handleGroupFormLabelKeyup(event: any) {
        if (!event || event.key !== 'Enter') return;
        if (this.labelEventComposing(event)) return;
        event.preventDefault();
        if (this.addGroupFormLabel(this.labelEventValue(event, this.groupForm.labelInput))) {
            this.clearLabelEventValue(event);
        }
    }

    public projectTypeTabClass(current: string, value: string) {
        const base = 'min-h-[58px] rounded-md border px-3 py-2 text-left transition-colors ';
        if (current === value) return base + 'border-slate-900 bg-slate-900 text-white shadow-sm';
        return base + 'border-transparent bg-transparent text-slate-600 hover:border-slate-300 hover:bg-white hover:text-slate-900';
    }

    public setFormOption(key: string, value: string) {
        this.form[key] = value;
        this.service.render();
    }

    public projectTypeLabel(type: string) {
        const option = this.projectTypeOptions.find((item) => item.value === type);
        return option ? option.label : '웹서비스';
    }

    public visibilityLabel(value: string) {
        const option = this.visibilityOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public projectStatusLabel(value: string) {
        if (value === 'deleted') return '삭제';
        const option = this.projectStatusOptions.find((item) => item.value === value);
        return option ? option.label : value;
    }

    public codexStatusLabel(project: any) {
        return project && project.codex_enabled ? '에이전트 활성' : '에이전트 비활성';
    }

    public codexBadgeClass(project: any) {
        if (project && project.codex_enabled) return 'whitespace-nowrap rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700';
        return 'whitespace-nowrap rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-500';
    }

    public codexAccountEmail(project: any) {
        const account = project && project.codex_status && project.codex_status.account ? project.codex_status.account : {};
        return account.email || account.name || '-';
    }

    public codexSubscriptionLabel(project: any) {
        if (!project || !project.codex_enabled) return '-';
        const status = project.codex_status || {};
        const account = status.account || {};
        const usage = status.usage || {};
        return account.plan || usage.summary || '구독 정보 없음';
    }

    public optionToggleClass(current: string, value: string) {
        const base = 'min-h-[74px] rounded-md border px-3 py-2 text-left transition-colors ';
        if (current === value) return base + 'border-slate-900 bg-slate-900 text-white';
        return base + 'border-slate-200 bg-white text-slate-600 hover:border-slate-400 hover:text-slate-900';
    }

    public htmlDocumentLayoutPresetClass(value: string) {
        return this.optionToggleClass(this.htmlDocumentLayout().preset, value);
    }

    public setHtmlLayoutPreset(option: any) {
        if (!option) return;
        const settings = this.ensureHtmlDocumentSettings();
        settings.layout.preset = option.value;
        settings.layout.render_mode = option.render_mode || 'web';
        if (option.value !== 'custom') {
            settings.layout.width = option.width;
            settings.layout.height = option.height;
        }
        this.form.default_viewport_width = settings.layout.width;
        this.form.default_viewport_height = settings.layout.height;
        this.service.render();
    }

    public updateHtmlLayoutWidth(value: any) {
        const settings = this.ensureHtmlDocumentSettings();
        settings.layout.preset = 'custom';
        settings.layout.width = Math.min(Math.max(Number(value) || 1440, 320), 7680);
        this.form.default_viewport_width = settings.layout.width;
    }

    public updateHtmlLayoutHeight(value: any) {
        const settings = this.ensureHtmlDocumentSettings();
        settings.layout.preset = 'custom';
        settings.layout.height = Math.min(Math.max(Number(value) || 900, 240), 7680);
        this.form.default_viewport_height = settings.layout.height;
    }

    public projectTargetLabel(project: any) {
        if (project && project.is_document_project && project.current_document_version) {
            return `${project.current_document_version.file_name} · ${this.projectDocumentVersionLabel(project)}`;
        }
        return project && project.link_url ? project.link_url : '-';
    }

    public reviewSummaryCount(summary: any, status: string) {
        if (status === 'total') return Number(summary && summary.total) || 0;
        const byStatus = summary && summary.by_status ? summary.by_status : {};
        return Number(byStatus && byStatus[status]) || 0;
    }

    public reviewSummaryTileClass(summary: any, status: string, activeBg: string, extra: string = '') {
        const base = `${extra ? `${extra} ` : ''}rounded-md px-1.5 py-1.5`;
        return `${base} ${this.reviewSummaryCount(summary, status) > 0 ? activeBg : 'bg-slate-50'}`;
    }

    public reviewSummaryLabelClass(summary: any, status: string, activeText: string, size: string = 'text-[10px]') {
        return `${size} ${this.reviewSummaryCount(summary, status) > 0 ? activeText : 'text-slate-300'}`;
    }

    public reviewSummaryCountClass(summary: any, status: string, activeText: string) {
        return `text-[13px] font-semibold ${this.reviewSummaryCount(summary, status) > 0 ? activeText : 'text-slate-300'}`;
    }

    public projectDocumentVersionLabel(project: any) {
        const version = project && project.current_document_version ? project.current_document_version : null;
        const value = version && (version.version_label || version.created);
        return this.service.formatter.kstDateTime(value, value || '-');
    }

    public applyUploadSettings(settings: any) {
        if (!settings || typeof settings !== 'object') return;
        this.uploadSettings = settings;
        const policy = this.uploadPolicy('project_document');
        const mimes = Array.isArray(policy.allowed_mimes) ? policy.allowed_mimes : [];
        this.documentUploadAccept = policy.allow_all_formats || mimes.indexOf('*/*') >= 0 ? '' : String(policy.accept || this.documentUploadAccept);
        this.documentUploadLimits = { fileBytes: Number(policy.max_file_bytes || this.documentUploadLimits.fileBytes) };
    }

    public uploadPolicy(key: string) {
        const policies = this.uploadSettings && this.uploadSettings.policies ? this.uploadSettings.policies : {};
        return policies && policies[key] ? policies[key] : {};
    }

    public fileExtension(name: any) {
        const match = String(name || '').toLowerCase().match(/\.[a-z0-9_-]+$/);
        return match ? match[0] : '';
    }

    public documentUploadValidationMessage(file: File) {
        const policy = this.uploadPolicy('project_document');
        const maxBytes = Number(policy.max_file_bytes || this.documentUploadLimits.fileBytes);
        if (maxBytes && file.size > maxBytes) return `파일은 최대 ${this.fileSizeLabel(maxBytes)}까지 업로드할 수 있습니다.`;
        if (policy && !policy.allow_all_formats) {
            const extensions = Array.isArray(policy.allowed_extensions) ? policy.allowed_extensions : [];
            const mimes = Array.isArray(policy.allowed_mimes) ? policy.allowed_mimes : [];
            if (mimes.indexOf('*/*') >= 0) return '';
            const ext = this.fileExtension(file.name);
            const mime = String(file.type || '').toLowerCase();
            const mimeAllowed = mime && mimes.some((item: any) => {
                const value = String(item || '').toLowerCase();
                return value === mime || (value.endsWith('/*') && mime.startsWith(value.slice(0, -1)));
            });
            if ((extensions.length || mimes.length) && extensions.indexOf(ext) < 0 && !mimeAllowed) return '허용되지 않는 파일 형식입니다.';
        }
        return '';
    }

    public fileSizeLabel(size: any) {
        const value = Number(size) || 0;
        if (value >= 1024 * 1024) return `${(value / 1024 / 1024).toFixed(1)} MB`;
        if (value >= 1024) return `${(value / 1024).toFixed(1)} KB`;
        return `${value} B`;
    }

    public documentUploadUrl() {
        return this.adminMode ? '/wiz/api/page.projects.mine.group/create_upload?admin=1' : '/wiz/api/page.projects.mine.group/create_upload';
    }

    public documentFile(document: any = null) {
        const target = document || this.form.document;
        return target && target.file instanceof File ? target.file : null;
    }

    public normalizeUploadResponse(response: any) {
        if (response && typeof response.code === 'number') return response;
        if (response && typeof response.responseJSON === 'object') return response.responseJSON;
        if (response && typeof response.responseText === 'string') {
            try {
                return JSON.parse(response.responseText);
            } catch (e) { }
        }
        if (typeof response === 'string') {
            try {
                return JSON.parse(response);
            } catch (e) { }
        }
        return { code: 500, data: { message: '프로젝트를 저장하지 못했습니다.' } };
    }

    public startDocumentUploadProgress(file: File) {
        this.documentUploadProgress = {
            visible: true,
            fileName: file && file.name ? file.name : 'document.pdf',
            percent: 0,
            loaded: 0,
            total: Number(file && file.size || 0),
            status: 'uploading',
            message: 'PDF 파일을 업로드하는 중입니다.'
        };
    }

    public async updateDocumentUploadProgress(percent: number, total: number, position: number) {
        this.documentUploadProgress = Object.assign({}, this.documentUploadProgress || {}, {
            visible: true,
            percent: Math.max(0, Math.min(100, Math.round(Number(percent || 0)))),
            loaded: Number(position || 0),
            total: Number(total || this.documentUploadProgress.total || 0),
            status: 'uploading',
            message: 'PDF 파일을 업로드하는 중입니다.'
        });
        await this.service.render();
    }

    public finishDocumentUploadProgress(success: boolean, message: string = '') {
        this.documentUploadProgress = Object.assign({}, this.documentUploadProgress || {}, {
            visible: true,
            percent: success ? 100 : Number(this.documentUploadProgress.percent || 0),
            loaded: success ? Number(this.documentUploadProgress.total || 0) : Number(this.documentUploadProgress.loaded || 0),
            status: success ? 'done' : 'error',
            message: message || (success ? '업로드가 완료되었습니다.' : '업로드하지 못했습니다.')
        });
        if (success) {
            window.setTimeout(async () => {
                if (this.documentUploadProgress && this.documentUploadProgress.status === 'done') {
                    this.documentUploadProgress = Object.assign({}, this.documentUploadProgress, { visible: false });
                    await this.service.render();
                }
            }, 1400);
        }
    }

    public documentUploadProgressPercent() {
        const progress = this.documentUploadProgress || {};
        const total = Number(progress.total || 0);
        if (total > 0) return Math.max(0, Math.min(100, Math.round(Number(progress.loaded || 0) / total * 100)));
        return Math.max(0, Math.min(100, Math.round(Number(progress.percent || 0))));
    }

    public documentUploadProgressMeta() {
        const progress = this.documentUploadProgress || {};
        if (Number(progress.total || 0) > 0) {
            return `${this.fileSizeLabel(progress.loaded || 0)} / ${this.fileSizeLabel(progress.total || 0)}`;
        }
        return progress.message || '';
    }

    public async submitCreateProject(payload: any) {
        const documentFile = this.isDocumentType(payload && payload.project_type) ? this.documentFile(payload && payload.document) : null;
        if (!documentFile) {
            return await wiz.call('create', { data: JSON.stringify(payload) });
        }
        payload.document = {
            name: payload.document && payload.document.name ? payload.document.name : documentFile.name,
            mime: payload.document && payload.document.mime ? payload.document.mime : (documentFile.type || 'application/pdf'),
            size: payload.document && payload.document.size ? payload.document.size : documentFile.size
        };
        const fd = new FormData();
        fd.append('data', JSON.stringify(payload));
        fd.append('file', documentFile);
        this.startDocumentUploadProgress(documentFile);
        await this.service.render();
        const response = this.normalizeUploadResponse(await this.service.file.upload(this.documentUploadUrl(), fd, async (percent: number, total: number, position: number) => {
            await this.updateDocumentUploadProgress(percent, total, position);
        }));
        this.finishDocumentUploadProgress(response.code === 200, response.code === 200 ? '업로드가 완료되었습니다.' : (response.data && response.data.message) || '업로드하지 못했습니다.');
        return response;
    }

    public documentUploadDropClass() {
        const base = 'flex flex-col gap-3 rounded-md border border-dashed border-slate-300 bg-slate-50 p-4 transition sm:flex-row sm:items-center sm:justify-between';
        if (this.documentBusy) return `${base} cursor-not-allowed opacity-60`;
        if (!this.documentDropActive) return base;
        return `${base} border-slate-900 bg-white ring-2 ring-inset ring-slate-900`;
    }

    public hasDocumentUploadFiles(event: any) {
        const transfer = event && event.dataTransfer ? event.dataTransfer : null;
        if (!transfer) return false;
        if (transfer.files && transfer.files.length) return true;
        const types = transfer.types ? Array.prototype.slice.call(transfer.types) : [];
        return types.indexOf('Files') >= 0;
    }

    public documentUploadEventFiles(event: any): File[] {
        if (event && event.dataTransfer) {
            event.preventDefault();
            event.stopPropagation();
        }
        const input = event && event.target ? event.target : null;
        const transfer = event && event.dataTransfer ? event.dataTransfer : null;
        const source = transfer && transfer.files && transfer.files.length ? transfer.files : input && input.files ? input.files : [];
        const files = Array.prototype.slice.call(source || []).filter((file: File) => !!file);
        if (input && input.value !== undefined) input.value = '';
        this.documentDropActive = false;
        return files;
    }

    public async onDocumentUploadDragOver(event: any) {
        if (!this.hasDocumentUploadFiles(event)) return;
        event.preventDefault();
        event.stopPropagation();
        if (this.documentBusy) {
            if (event.dataTransfer) event.dataTransfer.dropEffect = 'none';
            return;
        }
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
        if (!this.documentDropActive) {
            this.documentDropActive = true;
            await this.service.render();
        }
    }

    public async onDocumentUploadDragLeave(event: any) {
        const current = event && event.currentTarget ? event.currentTarget : null;
        const related = event && event.relatedTarget ? event.relatedTarget : null;
        if (current && related && current.contains && current.contains(related)) return;
        if (this.documentDropActive) {
            this.documentDropActive = false;
            await this.service.render();
        }
    }

    public async selectDocumentFile(event: any) {
        const files = this.documentUploadEventFiles(event);
        if (this.documentBusy || !files.length) return;
        if (files.length !== 1) {
            await this.service.modal.error('PDF 파일은 한 번에 하나만 선택해주세요.');
            return;
        }
        const file = files[0];
        const validationMessage = this.documentUploadValidationMessage(file);
        if (validationMessage) {
            await this.service.modal.error(validationMessage);
            return;
        }

        this.documentBusy = true;
        await this.service.render();
        try {
            this.form.document = {
                name: file.name,
                mime: file.type || 'application/octet-stream',
                size: file.size,
                file
            };
        } catch (e) {
            await this.service.modal.error('PDF 파일을 읽지 못했습니다.');
        }
        this.documentBusy = false;
        await this.service.render();
    }
}

export default PageProjectsMineGroupComponent;